import React from 'react';
import CommiteeCard from './CommiteeCard';
import './style.css';
import useLocalization from '../../../Localization';

const StandingCommiteeListing = ({
  data,
  usedForLeadership = false,
  heading,
}) => {
  const {ApplicationString} = useLocalization();

  return (
    <React.Fragment>
      <div className='Commitee-listing-main'>
        {heading && (
          <div
            className={
              usedForLeadership
                ? 'Commitee-listing-heading'
                : 'Commitee-listing-sub-heading'
            }>
            <p>{heading}</p>
            <span className='sub-heading-standing-committee'>
              {
                ApplicationString[
                  'chapterPage.chapterHeading.subtitle'
                ]
              }
            </span>
          </div>
        )}
        <div className='Commitee-listing-container-advisors'>
          {data?.length > 0 &&
            data?.map((CommiteeItem) => {
              // Card is clickable if it has either details or profile image
              const hasDetails =
                CommiteeItem?.details &&
                CommiteeItem?.details.trim() !== '' &&
                CommiteeItem?.details !== '<p></p>';
              const hasProfileImage =
                CommiteeItem?.profile_id?.name || CommiteeItem?.profile;
              const allowReadMore = hasDetails || hasProfileImage;

              return (
                <CommiteeCard
                  key={CommiteeItem.id}
                  allowReadMore={allowReadMore}
                  data={CommiteeItem}
                />
              );
            })}
        </div>
      </div>
    </React.Fragment>
  );
};

export default StandingCommiteeListing;
